"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  data: function data() {
    return {
      loading: false,
      tableData: [{
        reference: '（2019）赣国仲网字第1号',
        acceptNum: '4500004',
        application: '万海融资租赁（东莞）有限公司',
        respondent: '张时',
        operate: '民间金融纠纷',
        subjectMatter: '10000',
        arbitration: '200',
        status: '待一审',
        origin: '互仲链'
      }],
      currentPage: 4,
      reconciliationVisible: false,
      //对账弹窗显示
      receivablesVisible: false,
      //收款弹窗显示
      formLabelWidth: '120px',
      form: {
        name: '',
        tip: ''
      }
    };
  },
  methods: {
    // 分页事件
    handleSizeChange: function handleSizeChange(val) {},
    handleCurrentChange: function handleCurrentChange(val) {}
  }
};
exports.default = _default;